// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__axIZw","cell":"ColumnAccessor_cell__3Wxgy","firstCellAccent":"ColumnAccessor_firstCellAccent__3Hal8"};